<template>
  <div class="workflow-tooltip-wrapper">
    <div
      class="workflow-tooltip-content"
      :class="{ active: isTooltipVisible }"
      ref="tooltip"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WorkflowDescriptionTooltip',

  data() {
    return {
      isTooltipVisible: false,
    };
  },
  methods: {
    setToolTipPosition() {
      const tooltipWrapperElement = this.$el;

      const closestTaskListElement =
        tooltipWrapperElement.closest('.task-list');
      const closestTaskListElementrect =
        closestTaskListElement.getBoundingClientRect();

      const tooltipElement = this.$refs.tooltip;
      const tooltipElementRect = tooltipElement.getBoundingClientRect();

      const spaceAbove =
        tooltipElementRect.top - closestTaskListElementrect.top;
      const spaceBelow =
        closestTaskListElementrect.bottom - tooltipElementRect.top;

      if (spaceBelow > spaceAbove) {
        tooltipElement.style.maxHeight = spaceBelow - 20 + 'px';
      } else {
        tooltipElement.style.bottom = '30px';
        tooltipElement.style.maxHeight = spaceAbove - 20 - 30 + 'px';
      }

      this.isTooltipVisible = true;
    },
  },
  mounted() {
    this.setToolTipPosition();
  },
};
</script>

<style scoped>
.workflow-tooltip-wrapper {
  position: relative;
  filter: drop-shadow(0px 0px 0px rgba(0, 0, 0, 0));
}

/* .workflow- . */
.workflow-tooltip-wrapper .workflow-tooltip-content {
  position: absolute;
  background-color: #333343;
  border-radius: 5px;
  width: 100%;
  padding: 15px;
  color: #ffffff;
  opacity: 0;
  overflow: auto;
  user-select: text;
  font-size: 14px;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  width: auto;
}

.workflow-tooltip-wrapper .workflow-tooltip-content.active {
  opacity: 1;
}
</style>
